import { render, staticRenderFns } from "./DetalleDespacho.vue?vue&type=template&id=ebdd07b6"
import script from "./DetalleDespacho.vue?vue&type=script&lang=js"
export * from "./DetalleDespacho.vue?vue&type=script&lang=js"
import style0 from "./DetalleDespacho.vue?vue&type=style&index=0&id=ebdd07b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports